/**
 * Returns a shallow-ish clone of param.
 * Uses json parse, stringify so no support for
 * es6 structures (symbols, sets, maps, etc), dates, functions, undefined
 * @param {obj|array|string|number|null} obj - The thing to be cloned
 * @return {obj|array|string|number|null} A cloned thing
 */
var JSONClone = function(obj) {
    return JSON.parse(JSON.stringify(obj));
};

/**
 * Returns a shallow-ish clone of param
 * Currently no support for es6 structures (symbols, sets, maps, etc),
 * dates, functions
 * @param {obj|array|string|number|null|undefined} obj - The thing to be cloned
 * @return {obj|array|string|number|null|undefined} A cloned thing
 */
var lightClone = function(obj) {
    return obj === void 0 ? obj : JSONClone(obj);
};

module.exports = {
    JSONClone: JSONClone,
    lightClone: lightClone
};
